import { format } from '@if/core/date'
import { formatCurrency } from '@if/core/utils'
import { Box, Typography } from '@mui/material'
import { PaymentMethodIconComponent } from '@src/components/LoanCalendar/PaymentMethodIconComponent'
import { CustomerPaymentOperation } from '@src/types/loan/loan-operation'
import { useMemo } from 'react'

interface Props {
  threeNextPayments: CustomerPaymentOperation[]
}

const LoanNextPaymentCardContent = ({ threeNextPayments }: Props) => {
  const threeNextPaymentsRows = useMemo(
    () =>
      threeNextPayments.map((payment) => (
        <Box key={payment.id} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="caption" component="p">
            {format(payment.effectiveDate, 'P')}
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="caption" component="p">
              {formatCurrency(payment.amount)}
            </Typography>

            <PaymentMethodIconComponent paymentMode={payment.paymentMethodId} />
          </Box>
        </Box>
      )),
    [threeNextPayments],
  )

  return <>{threeNextPaymentsRows}</>
}

export default LoanNextPaymentCardContent
